import GiftPlaceholder from './GiftPlaceholder'

export default GiftPlaceholder
// eslint-disable-next-line import/export
export * from './GiftPlaceholder'
